import { render, staticRenderFns } from "./chip-primary5.vue?vue&type=template&id=74280ffb&scoped=true&"
import script from "./chip-primary5.vue?vue&type=script&lang=js&"
export * from "./chip-primary5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74280ffb",
  null
  
)

export default component.exports